export enum CustomerStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED'
}

export const CUSTOMER_STATUS_MAP = {
  [CustomerStatus.ACTIVE]: 'Active',
  [CustomerStatus.CLOSED]: 'Closed',
};